module.exports = __webpack_public_path__ + "static/media/translator-icon.f6944f6d.svg";